export enum Previews {
  Image = "image/png",
  Video = "video/mp4",
  PDF = "application/pdf",
  File = "File",
  Zip = "Zip",
  Document = "Document",
}